import { Text } from '@nike/eds';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setNposErrors } from '../../../../../redux/actions';
import FilterRow, { FilterGroup } from '../../reusable/Layout';
import TextInput from '../../reusable/TextInput/TextInput';

const { Default: _, match } = require('@nike/rcf-fp');

const AmountRange = ({ onFilterValueChange, translations }) => {
  const { minimumAmount, maximumAmount } = useSelector((state) => state.nposFilters);

  const errors = useSelector((state) => state.nposErrors);

  const dispatch = useDispatch();

  useEffect(() => {
    const getError = () => match()(
        [() => (minimumAmount && !maximumAmount) || (!minimumAmount && maximumAmount), translations.RL_ErrAmountRequired],
        [() => (minimumAmount && maximumAmount && minimumAmount > maximumAmount), translations.RL_ErrMinAmount],
        [_, null],
      );

    dispatch(setNposErrors({
      transactionAmount: getError(),
    }));
  }, [minimumAmount, maximumAmount, dispatch, translations.RL_ErrAmountRequired, translations.RL_ErrMinAmount]);

  return (
    <FilterGroup>
      <FilterRow>
        <Text className="filter-name">{translations.RL_AmountRange}</Text>
        <div className="d-sm-flx flx-dir-sm-r no-error-label" style={{ gap: '12px' }}>
          <TextInput
            data-testid="amount-range-min-input"
            errorMessage={errors.transactionAmount}
            hasErrors={!!errors.transactionAmount}
            id="minimumAmount"
            inputMode="numeric"
            label={translations.RL_Minimum}
            placeholder={translations.RL_Minimum}
            style={{ minWidth: '250px' }}
            type="number"
            value={minimumAmount}
            onChange={onFilterValueChange}
          />

          <TextInput
            data-testid="amount-range-max-input"
            errorMessage=" "
            hasErrors={!!errors.transactionAmount}
            id="maximumAmount"
            label={translations.RL_Maximum}
            placeholder={translations.RL_Maximum}
            style={{ minWidth: '250px' }}
            type="number"
            value={maximumAmount}
            onChange={onFilterValueChange}
          />
        </div>
      </FilterRow>
    </FilterGroup>
  );
};

AmountRange.propTypes = {
  onFilterValueChange: PropTypes.func.isRequired,
  translations: PropTypes.shape().isRequired,
};

export default AmountRange;
